<template>
  <div>
    <!-- Filter Start -->
    <div class="innerBox filter">
      <div class="d-flex flex-row justify-content-between">
        <h2 class="page-title">Highlight</h2>
        <div class="d-flex flex-row justify-content-end">
          <template v-if="user.type !== 'ADMIN_EKSPEDISI'">
            <div class="mr-3">
              <Multiselect
                :options="regions"
                placeholder="All Region"
                v-model="filter.region"
                class="tms-multiselect"
              />
            </div>
            <div class="mr-3">
              <Multiselect
                :options="ekspedisi.map((x) => x.id)"
                :custom-label="(opt) => ekspedisi.find((x) => x.id == opt).kode"
                placeholder="All Ekspedisi"
                v-model="filter.ekspedisi"
                class="tms-multiselect"
              />
            </div>
            <div class="mr-3">
              <div class="input-group">
                <flat-pickr
                  :config="rangePickr"
                  placeholder="Select Date"
                  v-model="selected.date"
                ></flat-pickr>
                <span
                  class="input-group-text bg-white"
                  style="
                    border-top-left-radius: 0;
                    border-bottom-left-radius: 0;
                    border: 0;
                    box-shadow: 0 0 6px #0000000f;
                    background-color: #ededed !important;
                  "
                >
                  <i class="fas fa-calendar" style="color: black"></i>
                </span>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="mr-3">
              <Multiselect
                :options="regions"
                placeholder="All Region"
                v-model="filter.region"
                class="tms-multiselect"
              />
            </div>
            <div class="mr-3">
              <div class="input-group">
                <flat-pickr
                  :config="rangePickr"
                  placeholder="Select Date"
                  v-model="selected.date"
                ></flat-pickr>
                <span
                  class="input-group-text bg-white"
                  style="
                    border-top-left-radius: 0;
                    border-bottom-left-radius: 0;
                    border: 0;
                    box-shadow: 0 0 6px #0000000f;
                    background-color: #ededed !important;
                  "
                >
                  <i class="fas fa-calendar" style="color: black"></i>
                </span>
              </div>
            </div>
          </template>
          <a href="" class="btn" style="    margin-right: -1rem !important;
    padding: 0;">
            <img src="@/assets/img/notification.svg" alt="" style="display: none;">
          </a>
        </div>
      </div>
    </div>
    <!-- Filter End -->

    <!-- {{ data.stats }} -->
    <!-- Stats Start -->
    <div class="row">
      <div class="col-lg-4 col-md-6">
        <div class="innerBox mt-4">
          <highlight-label-maker-stats
            title="Leadtime"
            :value="
              data.stats
                ? data.stats.lead_time
                  ? data.stats.lead_time
                  : '0'
                : 'Loading...'
            "
            unit="%"
            icon="fa-hourglass"
            detail="comment"
            style="color: #eaeaea"
          ></highlight-label-maker-stats>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="innerBox mt-4">
          <highlight-label-maker-stats
            title="Defect"
            :value="
              data.stats
                ? data.stats.defect_rate != null
                  ? data.stats.defect_rate
                  : 0
                : 'Loading...'
            "
            unit="%"
            icon="fa-exclamation-circle"
            style="color: #ffc1c1"
          ></highlight-label-maker-stats>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="innerBox mt-4">
          <highlight-label-maker-stats
            title="Service Rate"
            :value="
              data.stats
                ? data.stats.service_rate != null
                  ? data.stats.service_rate
                  : 0
                : 'Loading...'
            "
            unit="%"
            icon="fa-boxes"
            style="color: #bfc7ff"
          ></highlight-label-maker-stats>
        </div>
      </div>
    </div>
    <!-- Stats End -->

    <!-- Second Content Start -->
    <div class="row">
      <!-- Leadtime Transporter Table Start  -->
      <div class="col-lg-7 col-md-6">
        <div class="innerBox mt-4">
          <h5 class="elegant--sub-title">
            Leadtime Transporter
            <!-- <i
                            class="fas fa-info-circle"
                            :id="'ScanInfo'"
                        ></i>
                        <b-popover target="ScanInfo" triggers="hover" placement="top">
                            <template #title>Scan vs Active QR</template>
                            {{tooltip.scan_vs_active}}
                        </b-popover> -->
          </h5>
          <div style="height: 300px">
            <table class="table tms-table">
              <thead>
                <tr>
                  <th>No.</th>
                  <th>Ekspedisi</th>
                  <th>Nopol</th>
                  <th>Leadtime</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(item, index) in leadTimes">
                  <tr :key="index">
                    <td>{{ index + 1 }}.</td>
                    <td>{{ item.ekspedisi }}</td>
                    <td>{{ item.nopol }}</td>
                    <td>{{ item.leadtime }}</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!-- Leadtime Transporter Table End  -->
      <!-- Most Defect Part Chart Start -->
      <div class="col-lg-5 col-md-6">
        <div class="innerBox mt-4">
          <h5 class="elegant--sub-title">
            Most Defect Part
            <!-- <i
                            class="fas fa-info-circle"
                            :id="'ScanInfo'"
                        ></i>
                        <b-popover target="ScanInfo" triggers="hover" placement="top">
                            <template #title>Scan vs Active QR</template>
                            {{tooltip.scan_vs_active}}
                        </b-popover> -->
          </h5>
          <highlight-most-defect-part-chart ref="pieChart" :filter="filter">
          </highlight-most-defect-part-chart>
        </div>
      </div>
      <!-- Most Defect Part Chart Start -->
    </div>
    <!-- Second Content End  -->

    <!-- Headline News Start -->
    <div class="col-md-13 mt-4" v-if="data.headlineNews && data.news">
      <div class="innerBox chart">
        <div class="title">
          <h5 class="elegant--sub-title">Headline News</h5>
        </div>
        <div class="headline-box">
          <div class="row">
            <div class="col-12 mb-3">
              <div class="row">
                <div class="col-lg-8">
                  <div class="headline-box__image large">
                    <img
                      class="img-fluid"
                      :src="
                        data.headlineNews.image
                          ? data.headlineNews.image
                          : 'No Image'
                      "
                    />
                  </div>
                </div>
                <div class="col-lg-4">
                  <h2 class="headline-box__title">
                    {{ data.headlineNews.title }}
                  </h2>
                  <div class="headline-box__short">
                    {{ data.headlineNews.description }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4" v-for="news in data.news" :key="news.id">
              <div class="headline-box__image">
                <img
                  class="img-fluid"
                  :src="news.image ? news.image : 'No Image'"
                  alt="Image Not Found"
                />
              </div>
              <h2 class="headline-box__title">{{ news.title }}</h2>
              <div class="headline-box__short">{{ news.description }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Headline News End  -->
  </div>
</template>

<script>
// import highlightFilter from '@/components/filter/highlightFilter'
import qs from "qs";
import axios from "axios";
import moment from "moment";
import highlightLabelMakerStats from "./children/HighlightLabelMakerStats";
import Multiselect from "vue-multiselect";
import highlightMostDefectPartChart from "./children/highlightMostDefectPartChart";

export default {
  metaInfo: {
    title: "Highlight",
  },
  data() {
    let startDate = moment().startOf("month").format("YYYY-MM-DD");
    let currentDate = moment().format("YYYY-MM-DD");
    let user = this.$store.getters.currentUser;

    return {
      leadTimes: [],
      regions: this.$store.getters.getRegion,
      ekspedisi: this.$store.getters.getEkspedisi,
      user,
      tooltip: this.$store.state.tooltip.highlight.label_maker,
      filter: {
        start: startDate,
        end: currentDate,
        region: null,
        ekspedisi: null,
      },
      data: {
        stats: {
          defect_rate: null,
          service_rate: null,
          lead_time: null,
        },
        news: null,
        headlineNews: null,
        leadTime: null,
      },
      options: {
        labelMaker: this.$store.getters.getLabelMaker,
      },
      rangePickr: {
        mode: "range",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d M Y",
        altInputClass: "form-control input grey-flatpickr",
      },
      selected: {
        dateButtonsIndex: 2,
        date: `${startDate} to ${currentDate}`,
      },
    };
  },
  components: {
    // highlightFilter,
    Multiselect,
    highlightLabelMakerStats,
    highlightMostDefectPartChart,
  },
  mounted() {
    this.fetchData();
  },
  watch: {
    filter: {
      deep: true,
      handler: "fetchData",
    },
    "selected.date"() {
      let split = this.selected.date.split(" to ");
      this.filter.start = split[0];
      this.filter.end = split.length > 1 ? split[1] : split[0];

      //Check End
      if (this.filter.end != moment().format("YYYY-MM-DD")) {
        this.selected.dateButtonsIndex = -1;
        //Check Start
      } else if (
        this.options.dateButtons
          .map((x) => x.start)
          .indexOf(this.rangePickr.start) == -1
      ) {
        this.selected.dateButtonsIndex = -1;
        //Found Match
      } else {
        this.selected.dateButtonsIndex = this.options.dateButtons
          .map((x) => x.start)
          .indexOf(this.rangePickr.start);
      }

      this.vue_universal_table.update++;
      this.modal.edit = false;
      this.modal.new = false;
    },
    "selected.dateButtonsIndex"() {
      // this.filter.filter = this.selected.dateButtonsIndex != -1 ? this.options.dateButtons[this.selected.dateButtonsIndex].filter : 'CUSTOM'
    },
  },
  methods: {
    // recursiveNull (obj) {
    //     if(!obj || typeof obj != 'object'){
    //         obj = null
    //         return
    //     }
    //     let keys = Object.keys(obj)

    //     for(var i = 0 ; i < keys.length; i++) {

    //         if(typeof obj[keys[i]] == 'object')
    //             this.recursiveNull(obj)
    //         else
    //             obj[keys[i]] = null
    //     }

    // },
    fetchData() {
      //Reset All Data to null
      // for (var i in this.data) this.data[i] = null;
      // this.recursiveNull(this.data)
      let vm = this;
      vm.data.stats.lead_time = null;
      vm.data.stats.service_rate = null;
      vm.data.stats.defect_rate = null;
      vm.data.leadTime = null;

      if (this.filter.region === 'All' || this.filter.ekspedisi === 999) {
        this.filter = {...this.filter, region: null, ekspedisi: null};
      }

      //Remove filter from filter
      let filterlessFilter = JSON.parse(JSON.stringify(this.filter));
      console.log(
        "%cHighlightLabelMaker.vue line:274 filterlessFilter",
        "color: #007acc;",
        filterlessFilter
      );
      delete filterlessFilter.filter;

      //Get Leadtime Stats
      this.$http
        .get(
          `/api/home/stats/lead-time?${qs.stringify(filterlessFilter, {
            skipNulls: true,
            arrayFormat: "comma",
          })}`
        )
        .then((resp) => {
          vm.data.stats.lead_time = resp.data.data.lead_time.replace("%", "");
        })
        .catch((err) => {
          console.log(err);
        });

      //Get Defect Stats
      this.$http
        .get(
          `/api/home/stats/defect-rate?${qs.stringify(filterlessFilter, {
            skipNulls: true,
            arrayFormat: "comma",
          })}`
        )
        .then((resp) => {
          vm.data.stats.defect_rate = resp.data.data.defect_rate;
        })
        .catch((err) => {
          console.log(err);
        });

      //Get Service Rate Stats
      this.$http
        .get(
          `/api/home/stats/service-rate?${qs.stringify(filterlessFilter, {
            skipNulls: true,
            arrayFormat: "comma",
          })}`
        )
        .then((resp) => {
          vm.data.stats.service_rate = resp.data.data.service_rate;
        })
        .catch((err) => {
          console.log(err);
        });

      // Fetch data using Axios
      axios
        .get(
          `/api/home/table/lead-time?${qs.stringify(this.filter, {
            skipNulls: true,
            arrayFormat: "comma",
          })}`
        )
        .then((response) => {
          this.leadTimes = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });

      let filterNews = this.filter;
      filterNews.limit = 4;
      let filterlessFilterNews = JSON.parse(JSON.stringify(filterNews));
      this.$http
        .get(
          `/api/home/news?${qs.stringify(filterlessFilterNews, {
            skipNulls: true,
            arrayFormat: "comma",
          })}`
        )
        .then((resp) => {
          let data = resp.data.data;
          console.log(data);

          this.data.headlineNews = data[0];
          this.data.news = data.slice(1, data.length);
        })
        .catch((err) => {
          console.log(err);
        });

      this.$http
        .get(
          `/api/home/table/lead-time?${qs.stringify(filterlessFilter, {
            skipNulls: true,
            arrayFormat: "comma",
          })}`
        )
        .then((resp) => {
          this.data.leadTime = resp.data.data.map((val, i) => ({
            ...val,
            no: i + 1,
          }));
        })
        .catch((err) => console.err(err));
    },
  },
};
</script>

<style scoped>
.innerBox {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
}

.chart {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
  align-items: center;
}

.elegant--sub-title {
  font-size: 18px;
  font-weight: 500;
  color: #4d4d4d;
}

/* .center {
        padding: 50px 20px;
        display: flexbox;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    } */

.stats--icon {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.table td,
.table th {
  text-align: center;
}

.news-image-1 img {
  max-width: 100%; /* To make the image smaller and responsive */
}

.news-title-1 {
  text-align: left; /* To position the news-title on the top right */
}

.news-content-1 {
  text-align: left; /* To position the news-content on the bottom right */
}

.fa-exclamation-triangle {
  color: #ffc1c1;
}

.fa-hourglass {
  color: #eaeaea;
}

.fa-boxes {
  color: #bfc7ff;
}

.align-middle {
  display: flex;
  align-items: center;
}

.page-title {
  font-size: 27px;
  font-weight: bold;
  margin: 0;
}

.section-title {
  font-size: 20px;
  font-weight: bold;
  margin: 0;
  color: #4d4d4d;
}

/* tms-table start */
.tms-table {
  width: 100%;
  border-collapse: collapse;
}

.tms-table th,
.tms-table td {
  padding: 8px;
  text-align: left;
  vertical-align: middle;
}

/* Styling for table headers */
.tms-table th {
  color: #bcbcbc;
  font-weight: normal;
  border-bottom: 0px solid #e4e7ea;
}

/* Styling for table data cells */
.tms-table td {
  font-weight: normal;
}

/* Remove top border from first row */
.tms-table tr:first-child td {
  border-top: none;
}
/* tms-table end */

.headline-box .headline-box__image {
  border-radius: 10px;
  overflow: hidden;
}
.headline-box .headline-box__image img {
  object-fit: cover;
  max-height: 194px;
  min-height: 194px;
  width: 100%;
}
.headline-box .headline-box__image.large img {
  max-height: 367px;
  min-height: 367px;
}
.headline-box .headline-box__title {
  font-size: 35px;
  line-height: 42px;
  font-weight: bold;
  color: #4d4d4d;
  margin-top: 10px;
}
.headline-box .headline-box__short {
  margin-top: 10px;
  font-size: 20px;
  line-height: 24px;
  font-weight: 300;
  color: #4d4d4d;
  max-height: 72px;
  overflow: hidden;
}
</style>
